import { pecrCheck } from '../pecr/pecr';

function getStorageType(local) {
  return (!local) ? window.sessionStorage : window.localStorage;
}

/**
 * Checks if sessionStorage setItem is supported
 * setItem fails silently in Safari private mode and stops script execution
 * https://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an
 * @returns {boolean}
 */
export function isStorageSupported(local) {
  try {
    const storage = getStorageType(local);
    const testKey = local ? 'testLocalStorage' : 'testSessionStorage';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

export function getStorageItem(item, local) {
  if (isStorageSupported(local)) {
    const storage = getStorageType(local);
    return storage.getItem(item);
  }
  return '';
}

export function setStorageItem(args) {
  const {
    key,
    value,
    local,
    checkForPermission,
  } = args;

  if (isStorageSupported(local)) {
    const storageObject = getStorageType(local);

    if (checkForPermission) {
      const storageType = local ? 'localStorage' : 'sessionStorage';
      if (pecrCheck(storageType, key)) {
        storageObject.setItem(key, value);
      }
    } else {
      storageObject.setItem(key, value);
    }
  }
}

export function removeStorageItem(item, local) {
  if (isStorageSupported(local)) {
    const storage = getStorageType(local);
    storage.removeItem(item);
  }
}

export function clearStorage({ local, preservedValues = null } = {}) {
  if (isStorageSupported(local)) {
    const storage = getStorageType(local);
    let preservedDataMap;

    if (preservedValues) {
      preservedDataMap = preservedValues.map((item) => {
        const value = getStorageItem(item.key, item.local);
        return {
          key: item.key,
          value,
          local: item.local,
        };
      });
    }

    storage.clear();

    if (preservedDataMap) {
      preservedDataMap.forEach((item) => {
        setStorageItem(item);
      });
    }
  }
}
